module.exports = __webpack_public_path__ + "img/605.3cc2c06b.jpg";